import SampleReportView from "@/components/samples/SampleReportView";
import { VEROGY_REPORT } from "@/data/sample-reports";

const VerogySample = () => <SampleReportView report={VEROGY_REPORT} />;

export default VerogySample;
